import type { Duration } from 'date-fns';
import { formatDuration, intervalToDuration } from 'date-fns';

type FormatDurationProps =
  | FormatDurationWithFromToProps
  | FormatDurationWithDurationProps;

interface FormatDurationWithFromToProps {
  from: Date;
  to: Date;
  duration?: never;
}

interface FormatDurationWithDurationProps {
  duration: Duration;
  from?: never;
  to?: never;
}

const FormatDuration = ({ from, to, duration }: FormatDurationProps) => {
  const d = duration ?? intervalToDuration({ start: from, end: to });
  const formattedDuration = formatDuration(d);

  return <>{formattedDuration}</>;
};

export default FormatDuration;
